import axios from 'axios';
import config from '../config/config';

const apiUrl = config.apiBaseUrl;

/**
 * Obtiene la lista de Pagos Autorizados.
 */
export const getTablaPagosAut = async (payload, signal) => {
  try {
    const res = await axios.post(`${apiUrl}/pagosAutTabla`, payload, { signal });
    return res.data;
  } catch (err) {
    if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') throw err;
    throw new Error('Error al cargar datos de pagos autorizados.');
  }
};

/**
 * Autoriza una solicitud en un nivel determinado.
 */
export const autorizarPago = async (idFolio, nivel, username, empresa) => {
  try {
    const res = await axios.get(`${apiUrl}/pagosAutAutorizar/${idFolio}/${nivel}/${username}/${empresa}`);
    return res.data;
  } catch (err) {
    throw new Error('Error al autorizar la solicitud.');
  }
};

/**
 * Rechaza o cancela la autorización de un pago.
 */
export const cancelarPago = async (payload) => {
  const { ID, EMPRESA, OBSERVACIONES, USUARIO, MOTIVO, DETALLE, SECCIONES, RECLASIFICAR } = payload;
  try {
    const res = await axios.post(`${apiUrl}/pagosAutCancelar`, {
      ID,
      EMPRESA,
      OBSERVACIONES,
      BORRAR: 0,
      USUARIO,
      MOTIVO,
      DETALLE,
      SECCIONES,
      RECLASIFICAR,
    });
    return res.data;
  } catch (err) {
    throw new Error('Error al cancelar la solicitud de pago.');
  }
};

/**
 * Obtener los archivos adjuntos de un pago.
 */
export const obtenerArchivosPago = async (id) => {
  try {
    const response = await axios.post(`${apiUrl}/pagosAutDescargar`, { id });
    return response.data;
  } catch (err) {
    throw new Error('Error al obtener archivos adjuntos.');
  }
};
